import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Avatar,
    ButtonBase,
    withRouter
} from '../../../material-ui';


const ICON_HUO = require("../../../images/icons/huo.png");

class AnchorTopItem extends React.Component {

    render() {
        const { classes, data, avatar, idx } = this.props;
        return (
            <Grid container direction='column' justifyContent='center' alignItems='center' style={{
                width: '100vw',
                paddingTop: 16,
            }}>
                <Grid container direction='row' justifyContent='space-between' alignItems='center'>
                    <Grid container direction='row' alignItems='center' style={{ flex: 1 }} >
                        <ButtonBase disableRipple className={classes.button} onClick={() => this.props.onClickAnchor && this.props.onClickAnchor()}>
                            <Grid style={{ paddingLeft: 32, paddingRight: 16 }}>
                                <Typography style={{ color: '#FFF', fontSize: 13 }}>{idx}</Typography>
                            </Grid>
                            <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                                <Grid>
                                    <Avatar src={data.portrait} className={classes.avatar} ></Avatar>
                                </Grid>
                                <Grid container direction='column' alignItems='flex-start' style={{ flex: 1, marginLeft: 16 }}>
                                    <Typography style={{ color: '#FFF', fontSize: 13 }}>{data.nickname}</Typography>
                                    <Grid container direction='row' alignItems='center'>
                                        <img src={ICON_HUO} className={classes.iconHuo}></img>
                                        <Typography style={{ color: '#4D4952', fontSize: 10 }}>{data.heat}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ButtonBase>
                    </Grid>
                    <Grid>
                        <ButtonBase
                            disableRipple
                            className={data.isStart ? classes.dy1Button : classes.dyButton}
                            onClick={() => this.props.onClick && this.props.onClick()}>{data.isStart ? '取消关注' : '关注'}</ButtonBase>
                    </Grid>
                </Grid>
                <Grid style={{ height: 1, backgroundColor: '#301C24', width: '90%', marginTop: 16 }}></Grid>
            </Grid >

        );
    }
}

export default withRouter(withStyles((theme) => ({
    avatar: {
        height: 40,
        width: 40,
    },
    iconHuo: {
        height: 8,
        width: 6,
        marginRight: 4,
    },
    iconRank: {
        height: 22,
        width: 22,
        position: 'absolute',
        left: 0,
        top: 10,
    },
    button: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
    },
    dyButton: {
        minWidth: 60,
        backgroundColor: theme.palette.primary.main,
        height: 25,
        borderRadius: 12.5,
        marginRight: 32,
        color: '#FFF',
        fontSize: 11,
    },
    dy1Button: {
        minWidth: 60,
        backgroundColor: 'transparent',
        height: 25,
        borderRadius: 12.5,
        marginRight: 32,
        color: '#7F708E',
        fontSize: 11,
        border: 'solid 1px #665B70'
    },
    buttonBase: {
        width: 86,
        height: 86,
    }
}))(AnchorTopItem));